<template>
  <a
    :href="node.data.url"
    :target="node.data.target || '_blank'"
    rel="noopener noreferrer"
  >
    <AppLink :underline="true">
      <slot />
    </AppLink>
  </a>
</template>

<script setup>
defineProps({
  node: {
    type: Object,
    required: true,
  },
});
</script>
